/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import InlineNoteEditor from 'DesignSystem/InlineNoteEditor/index'
import React from 'react'
import SegmentsWarning from './SegmentsWarning/index'
import SelectNumber from './SelectNumber/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/EditAutomation/EventActions/Content/EventAction/Content/Content/Content/SendCommunication/SMSTemplateEditor/Content"
  
}) {
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtSpaceXl = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xl'
        })
let eventActionDataSmsTemplateContentValueData = fromData.useDataValue({ viewPath,
context: 'event_action',
path: 'data.sms_template.content',
})
let constantData = 'sms-template-'
let eventActionIdValueData = fromData.useDataValue({ viewPath,
context: 'event_action',
path: 'id',
})
let aggregateData = fromAggregate.joinNoSpace(constantData, eventActionIdValueData)
let tokensValueData = fromData.useDataValue({ viewPath,
context: 'tokens',
})
let onChange = fromHelpers.useDataOnChange({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 marginBottom={dtSpaceXs}
 weight="medium"
 text="SMS"
/>
<SelectNumber
  viewPath={`${viewPath}/SelectNumber`}
/>
<div
  data-testid="Content.Vertical:1"
  data-view-path={viewPath}
 style={{'--mt-1-Z1Yf8zk': typeof dtSpaceXl === 'number' ? `${dtSpaceXl}px` : dtSpaceXl}}
 className={`views-block ${styles.Vertical1}`}
>
<InlineNoteEditor
  viewPath={`${viewPath}/InlineNoteEditor`}
 data="event_action.data.sms_template.content"
 value={eventActionDataSmsTemplateContentValueData}
 onChange={onChange}
 data="'sms-template-'"
 data="event_action.id"
 aggregate="/Data/aggregate.js joinNoSpace"
 containerId={aggregateData}
 marginTop={0}
 marginBottom={0}
 width="100%"
 parentHeight={200}
 toolbarPersist={true}
 toolbar="sms_template"
 maxLength={10}
 data="tokens"
 tokens={tokensValueData}
/>
</div>
<SegmentsWarning
  viewPath={`${viewPath}/SegmentsWarning`}
/>
</div>
{children}
</React.Fragment>)
}